import React, { Component } from 'react';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Box from '../ui/Box';

import DataService from '../../services/DataService'; 
var ds = DataService;

import LocalStroageService from '../../services/LocalStorageService';
var ls = LocalStroageService;

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      misMatchFlag: false,
      isDemoLogin: false,
    }
  }

  componentDidMount() {
    const userData = ls.getUserDetails();
    if (userData.is_demo_user) {
      this.setState({
        isDemoLogin: true
      });

    } else {
      this.setState({
        isDemoLogin: false
      });
    };
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value

    }, () => {
      if (this.state.newPassword !== '' && this.state.repeatNewPassword !== '') {
        if (this.state.newPassword.toString() !== this.state.repeatNewPassword.toString()) {
          this.setState({
            misMatchFlag: true
          });

        } else {
          this.setState({
            misMatchFlag: false
          });
        }
      }
    });
  }

  resetPassword(e) {
    e.preventDefault(e);
    const payLoad = {
      oldPassword: this.state.oldPassword,
      newPassword: this.state.newPassword
    };

    if (this.state.isDemoLogin === true) {
      this.props.unMountMe(true);
      return;
    }

    ds.postUpdatePassword(
      payLoad,
      data => {
        this.props.unMountMe(true)
      },
      err => {}
    );
  }

  render() {
    return (
      <Box header='Change Password'>
        <div className="col-sm-12">
          <form onSubmit={this.resetPassword.bind(this)}>
            <fieldset>
              <section>
                <TextField
                  floatingLabelText="Current Password"
                  name="oldPassword"
                  className="w-100"
                  value={this.state.oldPassword}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="New Password"
                  name="newPassword"
                  className="w-100"
                  value={this.state.newPassword}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Repeat New Password"
                  name="repeatNewPassword"
                  type="text"
                  className="w-100"
                  value={this.state.repeatNewPassword}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>
            </fieldset>

            <div className="mt-4vw align-right">
              {
                this.state.misMatchFlag === false ?
                  <RaisedButton
                    label="Reset Password"
                    primary
                    type="submit"
                  />
                : 
                <div style={{color: 'red', textAlign: 'center', fontSize: '1rem'}}>
                  ** New and Repeat New Passwords must be same.
                </div>
              }
              
            </div>
          </form>
        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/Header/ChangePassword.js